export default __webpack_public_path__ + "static/media/delivery_dash.1c31b20b.svg";